import type { TableParams } from '@ps/web-shared-api-types/v0/SwHomeGames';
import { useMemo } from 'react';

import type { SelectOption } from '@swf/components/Inputs/components/DropDown/DropDown';
import { PKR_DEFAULT_HOLDEM_GAME_CONFIG } from '@swf/poker';

import { fallback } from '../utils/common';

const useGetPlayersPerTable = (
  gameData: TableParams[],
  handTypeValue: string,
  gameType: TableParams['potStruct']
): SelectOption[] =>
  useMemo(() => {
    if (!gameData || !gameData.length) return fallback;

    const { handType, hiLo } = JSON.parse(handTypeValue);
    const data = gameData.filter(
      (item) => item.handType === handType && item.hiLo === hiLo && item.potStruct === gameType
    );

    const options = [...new Set(data.map((item) => Number(item.tableSize)))]
      .sort((a, b) => {
        // move items in front according to the given condition
        if (a === PKR_DEFAULT_HOLDEM_GAME_CONFIG.tableSize) return -1;
        if (b === PKR_DEFAULT_HOLDEM_GAME_CONFIG.tableSize) return 1;
        // sort items from largest to smallest
        return b - a;
      })
      .map((tableLimit) => ({ text: tableLimit, value: tableLimit }));

    if (!options || !options.length) return fallback;

    return options;
  }, [gameData, handTypeValue, gameType]);
export default useGetPlayersPerTable;
